import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const cut = (props) => (
  <SvgIcon width="15" height="15" viewBox="0 0 15 15" {...props}>
    <path
      d="M7.73,6.23A2.923,2.923,0,0,0,8,5,3,3,0,1,0,5,8a2.923,2.923,0,0,0,1.23-.27L8,9.5,6.23,11.27A2.923,2.923,0,0,0,5,11a3,3,0,1,0,3,3,2.923,2.923,0,0,0-.27-1.23L9.5,11l5.25,5.25H17V15.5ZM5,6.5A1.5,1.5,0,1,1,6.5,5,1.5,1.5,0,0,1,5,6.5Zm0,9A1.5,1.5,0,1,1,6.5,14,1.5,1.5,0,0,1,5,15.5ZM9.5,9.875A.375.375,0,1,1,9.875,9.5.371.371,0,0,1,9.5,9.875ZM14.75,2.75l-4.5,4.5,1.5,1.5L17,3.5V2.75Z"
      transform="translate(-2 -2)"
    />
  </SvgIcon>
);
export default cut;



// WEBPACK FOOTER //
// ./src/common/icons/Cut/index.tsx